import { WprDI_Control } from '../../wpr-framework/view/di/WprDI_Control';
import { WprControlInfo } from '../../wpr-framework/view/control/WprControlInfo';
import { WprDI_ScopeModel } from '../../wpr-framework/view/di/WprDI_ScopeModel';
import { WprModel } from '../../wpr-framework/view/deco/WprModel';
import { WprViewMode } from '../../wpr-framework/view/deco/WprViewMode';
import { RiskFactorMode } from './mode/RiskFactorMode';
import { WprValidError } from '../../wpr-framework/view/validation/WprValidError';
import { RiskFactorPHMode } from './mode/RiskFactorPHMode';
import { Calender } from '../../datepicker/Calender';
import { FirstScopeInfo } from '../../scope/FirstScopeInfo';
import { WlMasterDataRequest } from '../../service/service-models/wl-master/WlMasterDataRequest';
import { SystemService } from '../../service/SystemService';
import { WlMasterDataInfo } from '../../service/models/wl-master/wl-master-data-info';
import { WlDestinationMappingInfo } from '../../service/models/wl-destination-map/WlDestinationMappingInfo';
import { WprValueMap } from '../../wpr-framework/model/WprValueMap';
import { BaseWindowViewScope } from '../base/BaseWindowViewScope';
import { postUtagEvent, UTAG_EVENT_JSON } from '../../../public/utag';
import { RiskFactorInfo } from '../../service/models/risk-factor/risk-factor-info';
import { PlanByTravelWLRequest } from '../../service/service-models/plan-by-travel-wl/PlanByTravelWLRequest';
import { PlanByTravelWLService } from '../../service/PlanByTravelWLService';
import { PlanByTravelWL } from '../../service/models/plan-by-travel-wl/plan-by-travel-wl';
import { WprDI_GlobalScopeModel } from '../../wpr-framework/view/di/WprDI_GlobalScopeModel';
import { CollateralDisplayInfo } from '../../service/models/collateral-display/collateral-display-info';
import { CollateralInfo } from '../../models/CollateralInfo';
import { PlanInfo } from '../../models/PlanInfo';
import { CoverageInfo } from '../../models/CoverageInfo';
import { Coverage } from '../../service/models/coverage/coverage';
import { WlMasterMappingInfo } from '../../service/models/wl-master/wl-master-info';
import { OptionInfo } from '../../models/OptionInfo';
import { map } from 'jquery';
import { stringify } from 'querystring';
import { threadId } from 'worker_threads';

const parser = require('fast-xml-parser');
const he = require('he');

/**
 * 旅行内容のご確認
 */
export class RiskFactorComponentView extends BaseWindowViewScope<FirstScopeInfo> {
	// private 変数  ------------------------------------------------------------
	private m_Calender1: Calender							= null;			// 開始日
	private m_Calender2: Calender							= null;			// 終了日
	private m_CollKeyList: string[]							= [];			// 補償キーリスト
	public readonly EXTRA_COLLKEY_OTA: string 				= 'AT23';		// 	追加保障キー（OTA）
	public readonly EXTRA_COLLKEY_DTP: string 				= 'AT36';		// 	追加保障キー（DTP）
	// --------------------------------------------------------------------------

	// モデル  ------------------------------------------------------------------
	@WprDI_GlobalScopeModel('product')
	private m_ProductCode: string 							= null;			//	商品コード
	@WprDI_GlobalScopeModel('agentcode')
	private m_Agency: string 								= null;			//	代理店コード
	// WRQ-3496_ 【旅行保険】代理店追加対応 阪急交通社(ホワイトラベル）----------START
	@WprDI_GlobalScopeModel('inquiryNo')
	private m_MemberNo: string 								= null;			// 会員番号	
	// WRQ-3496_ 【旅行保険】代理店追加対応 阪急交通社(ホワイトラベル）----------END
	@WprDI_ScopeModel('RiskFactorInfo')
	@WprModel('RiskFactorInfo')
	private m_RiskFactorInfo: RiskFactorInfo 				= null;			// リスクファクター情報
	@WprModel('WlMasterDataInfo')
	private m_MasterData: WlMasterDataInfo 					= null;			// マスタデータ情報
	@WprModel('WlDestinationMappingInfo')
	private m_WlDestinationMappingInfo: WlDestinationMappingInfo = null;	//　渡航先マッピング情報
	@WprDI_Control
	@WprModel('periodFrom')
	private m_PeriodFrom: WprControlInfo 					= null;			//　開始日
	@WprDI_Control
	@WprModel('periodTo')
	private m_PeriodTo: WprControlInfo 						= null;			//　終了日
	// -------------------------------------------------------------------------
	
	// DI情報  ------------------------------------------------------------------
	@WprDI_Control
	private m_Dest: 		WprControlInfo 					= null; 		// 主な旅行先コントロール
	@WprDI_Control
	private m_Notice:		WprControlInfo 					= null; 		// 主な旅行先コントロール
	@WprDI_Control
	private m_pittari: WprControlInfo							= null;
	@WprDI_Control
	private m_next: WprControlInfo							= null;
	// --------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	constructor() {
		super('step1_riskfactor');
	}
	// --------------------------------------------------------------------------
	
	// サブビュー/モード  ---------------------------------------------------------
	@WprViewMode
	private m_ViewMode 										= new RiskFactorMode(); 		// リスクファクターモード
	@WprViewMode
	private m_ViewMode1 									= new RiskFactorPHMode(); 		// プレースホルダモード
	// --------------------------------------------------------------------------

	// サービス  -----------------------------------------------------------------
	private m_SystemService: SystemService 					= new SystemService();			// システムサービス
	private m_PlanService: PlanByTravelWLService			= new PlanByTravelWLService();	// プランサービス
	// ---------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * コントロール定義設定
	 */
	public onRegisterConfig(): void {
		this.addConfig('next', '次に進む', null);
		this.addConfig('pittari', 'ぴったり', null);
		this.addConfig('notice', 'お知らせXML', 'WlMasterDataInfo');
		this.addConfig('dest', '主な旅行先', 'RiskFactorInfo', 		{ bindName: 'destinationCountryCode', 	noEditClass: 'first', errorClass: 'error', hissu: true });
		this.addConfig('wlDestinationMappingList', 'WL渡航先マッピングリスト', 'WlDestinationMappingInfo');
		this.addConfig('periodFrom', '旅行期間(始期)', null, 		{ bindModel: true, 	hissu: true, noEditClass: 'first', category: 'DTP' });
		this.addConfig('periodTo', '旅行期間(終期)', null, 			{ bindModel: true, hissu: true, noEditClass: 'first' , category: 'DTP'});
		this.addConfig('systemDate', 'システム日付', 'WlMasterDataInfo');
		this.addConfig('person', '旅行人数', 'RiskFactorInfo', 		{ bindName: 'numberOfInsured',　noEditClass: 'first', errorClass: 'error', hissu: true, category: 'DTP' });
		this.addConfig('purpose', '旅行の目的', 'RiskFactorInfo', 	{ bindName: 'purposeCode', hissu: true, category: 'DTP'});
	}

	/**
	 * アクション登録
	 */
	public onRegisterAction(): void {
		this.addBlurAction('dest', null, true);
		this.addBlurAction('person', null, true);
		this.addAction('q-1', this.onHelpShow);
		this.addAction('q-2', this.onHelpShow);
		this.addAction('q-3', this.onHelpShow);
		this.addAction('q-4', this.onHelpShow);
		this.addAction('close', this.onClose);
		this.addAction('next', this.onNext);
	}

	/**
	 * 入力チェック（独自のValidationを実施する場合に使用する）
	 *   エラー追加例：WprValidError.addError('エラーメッセージ');
	 * 				  this.setControlError('control', 'error');
	 * @para actionName アクション名
	 * @para validError バリデーションエラー情報
	 */
	protected onValid(actionName: string, validError: WprValidError): void {
		if (this.m_Dest.value && this.m_Dest.value === 'CU') 
			this.setControlError('dest', '旅行先にキューバが含まれている場合は、保険の申込みができません。');
	}

	/**
	 * バリデーションエラーメッセージ通知
	 * @param name コントロール名
	 * @param rowIndex 行数(Listの場合)
	 * @param validatorName バリデーション名
	 * @param msg エラーメッセージ
	 * @returns エラーメッセージ（変更する場合に指定する、メッセージを使用しない場合は、nullを返す）
	 */
	public onInvalidMessage(name: string, rowIndex: number, validatorName: string, msg: string): string {
		if (validatorName === '必須') {
			if (name === 'dest') {
				return '旅行先を選択してください';
			}
			if (name === 'person') {
				return '旅行人数を選択してください';
			}
		}
		return msg;
	}

	/**
	 * ビュー表示通知
	 */
	public onShowView(): void {
		super.onShowView();
		if (!this.m_Agency || !(this.m_ProductCode == 'OTA' || this.m_ProductCode == 'DTP'))
			this.onViewError('ご指定のURLは見つかりませんでした。');
		const req: WlMasterDataRequest = new WlMasterDataRequest();
		req.companyProductCode = this.m_ProductCode;
		this.m_SystemService.getSystemCache(this, req, (result) => {
			this.m_MasterData = result.wlMasterDataInfo;
			const today = new Date(this.m_MasterData.systemDate);
			this.setNationValueMap(this.m_MasterData.wlDestinationMappingList);
			if (this.m_RiskFactorInfo.startDate || this.m_RiskFactorInfo.endDate) {
				this.m_PeriodFrom.value = this.m_RiskFactorInfo.startDate.replace(/-/g, '/');
				this.m_PeriodTo.value = this.m_RiskFactorInfo.endDate.replace(/-/g, '/');
			}
			this.m_Calender1 = Calender.init(this,'periodFrom', today, today, this.getEndDate(today, 60));
			this.m_Calender2 = Calender.init(this,'periodTo', today, today, this.getEndDate(today, 29));
			this.m_Dest.refresh();
			// お知らせXMLを取得
			this.m_SystemService.getNoticeXml(process.env.API_GET_NOTICE).then((xmlResult) => {
				if (xmlResult) {
					try {
						if (xmlResult.isAxiosError == true) {
							this.setViewMode('noticeView', '');
						}
						else if (xmlResult[0].status !== 200) {
							this.setViewMode('noticeView', '');
						}
						else {
							if (xmlResult[0].data === undefined || xmlResult[0].data === null) {
								this.setViewMode('noticeView', '');
							}
							else {
								const options = {
									attributeNamePrefix : '@_',
									attrNodeName: 'attr',
									textNodeName : '#text',
									ignoreAttributes : false,
									ignoreNameSpace : false,
									allowBooleanAttributes : false,
									parseNodeValue : true,
									parseAttributeValue : false,
									trimValues: true,
									cdataTagName: '__cdata',
									cdataPositionChar: '\\c',
									localeRange: '',
									parseTrueNumberOnly: false,
									attrValueProcessor: a => he.decode(a, {isAttributeValue: true}),
									tagValueProcessor : a => he.decode(a)
								};
								const xmlData = parser.parse(xmlResult[0].data, options);
								console.log(xmlData);
								if (xmlData.list.news === undefined || xmlData.list.news === null){
									this.setViewMode('noticeView', '');
								}
								else {
									for (let i: number = 0; i < xmlData.list.news.length; i++) {
										if (this.m_MasterData.notice === null)
											this.m_MasterData.notice = xmlData.list.news[i].text;
										else
											this.m_MasterData.notice += xmlData.list.news[i].text;
										if ((i + 1) != xmlData.list.news.length)
											this.m_MasterData.notice += '<br />';
									}
								}
							}
						}
					} catch (e) {
						this.setViewMode('noticeView', '');
					}
					if (this.m_MasterData.notice === null || this.m_MasterData.notice === '') {
						this.setViewMode('noticeView', '');
					}
					else {
						this.setViewMode('noticeView', '表示');
					}
				}
				else {
					this.setViewMode('noticeView', '');
				}
				if (this.checkRiskFactorInfoOnInit()) {
					this.m_pittari.setDisplay(true);
					this.m_next.setDisabled(false);
				}
				if (this.onUtagView2()) {
					$('#id-period-from').off('click');
					$('#id-period-to').off('click');
				}
				else {
					const idList: string[] =[];
					idList.push('#id-period-from');
					idList.push('#id-period-to');
					this.onUtagViewWithEventOff(idList);
				}
				this.refreshModel();
			});
		});
	}

	/**
	 * 値変更通知
	 * @param name 名前
	 * @param value 値
	 * @returns falseの場合、変更を取り消す
	 */
	public onChangeValue(name: string, value: any): boolean {
		if (name === 'dest' || name === 'person') {
			this.checkValidate(name);
		}
		else if (name === 'periodFrom') {
			const startDate = new Date(value);
			if (this.m_PeriodFrom.value >= this.m_PeriodTo.value) {
				this.m_PeriodTo.value = '';
			}
			this.m_Calender2.setDate(startDate, this.getEndDate(startDate, 29));
		}
		else if (name === 'purpose') {
			this.setViewMode(name,value);
		}
		this.setUtagEvent(name, value);
		this.refreshModel(name);
		return true;
	}

	/**
	 * 商品コード取得
	 */
	public get productCode(): string { 
		return this.m_ProductCode; 
	}
	// --------------------------------------------------------------------------

	// アクション  ---------------------------------------------------------------
	/**
	 * ヘルプ表示処理
	 */
	public onHelpShow(param: any): void {
		if (this.productCode === 'OTA') {
			if(param === 'q-2')
				param += '-1';
		}
		this.setViewMode('helpMode', param);
		this.refreshModel();
	}

	/**
	 * ヘルプ閉じる処理
	 */
	public onClose(param: any): void {
		this.setViewMode('helpMode', '');
		this.refreshModel();
	}

	/**
	 * 画面遷移処理
	 */
	public onNext(): void {
		const startDate = this.m_PeriodFrom.value.replace(/\//g, '-');
		const endDate = this.m_PeriodTo.value.replace(/\//g, '-');
		const systemDate:Date = new Date(this.m_MasterData.systemDate);
		this.setRiskFacrotInfo(startDate, endDate);
		let optionFlg: boolean = true;
		if (this.checkOption(systemDate, startDate) === false)
			optionFlg = false;
		const req: PlanByTravelWLRequest = new PlanByTravelWLRequest();
		req.riskFactorInfo = this.m_RiskFactorInfo;
		req.transactionDate = this.dateToString(systemDate);
		this.m_PlanService.planByTravelWL(this, req, (result) => {
			let resPlanList: PlanByTravelWL[] 				= result.planList;
			let planInfoList: PlanInfo[] 					= [];
			let resCollDispsList: CollateralDisplayInfo[] 	= result.collateralDisplayInfoList;
			this.setCollKey(resCollDispsList);
			let extraCollInfo 								= new CollateralDisplayInfo();
			let optionInfo 									= null;
			this.sortByPlanCode(resPlanList);
			let planMap: Map<string, PlanByTravelWL[]> = new Map<string, PlanByTravelWL[]>();

			// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 START
			//　方面グループコードはサーバ側からのレスポンスで取得
			this.m_RiskFactorInfo.destinationGroupCode 	= result.destinationGroupCode;
			// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 END

			for(let i=0; i<resPlanList.length; i++) {
				if (planMap.has(resPlanList[i].planSummary) == false)
					planMap.set(resPlanList[i].planSummary,[]);
				planMap.get(resPlanList[i].planSummary).push(resPlanList[i]);
			}
			planMap.forEach(
				(infoList: PlanByTravelWL[], summary: string) => {
					let addInfo: PlanInfo = new PlanInfo();
					for (let i = 0; i < infoList.length; i++) {
						let collSize: number = infoList[i].coverages.length;
						if (infoList[i].extraCoverageCode === null) {
							addInfo.planCode 		= infoList[i].planCode;
							addInfo.planName 		= infoList[i].planName;
							addInfo.summary 		= infoList[i].planSummary;
							addInfo.totalPremium	= infoList[i].totalPremium;
							addInfo.collInfoList 	= this.getCollInfoList(collSize, infoList[i].coverages);
							continue;
						}
						addInfo.optionCode = infoList[i].planCode;
						planInfoList.push(addInfo);
						if (optionInfo === null) {
							optionInfo = new OptionInfo();
							for(let j=0; j<collSize; j++) {
								let extraCollKey: string = infoList[i].coverages[j].coverageCd;
								if (extraCollKey === this.EXTRA_COLLKEY_OTA || extraCollKey === this.EXTRA_COLLKEY_DTP) {
									for(let key of resCollDispsList) {
										if (key.collateralKey === extraCollKey) {
											extraCollInfo = key;
											if (extraCollKey === this.EXTRA_COLLKEY_OTA) 
												extraCollInfo.collateralDescription = this.insertBr(key.collateralDescription);
											optionInfo.value7	 = String(infoList[i].extraCoverageAmount);
											optionInfo.optionFee = infoList[i].extraCoveragePremium;
										}
									}
								}
							}
						}
					}
				}	
			);
			let colMap: Map<string, CollateralDisplayInfo> = new Map<string, CollateralDisplayInfo>();
			for (let colDispInfo of resCollDispsList) {
				if (colMap.has(colDispInfo.collateralKey) === false)
					colMap.set(colDispInfo.collateralKey, colDispInfo);
			}
			// let collDispsList = this.getCollDispList(resCollDispsList);
			let collDispsList = this.getCollDispList(colMap);
			this.setScopeModel('OptionFlag', optionFlg);
			this.setScopeModel('OptionInfo', optionInfo);
			this.setScopeModel('ExtraCollDispInfo', extraCollInfo);
			this.setScopeModel('CollDispList', collDispsList);
			this.setScopeModel('CollKeyList', this.m_CollKeyList);
			this.setScopeModel('PlanInfoList', planInfoList);
			this.setScopeModel('RiskFactorInfo', this.m_RiskFactorInfo);
			this.pushPath('/step2_plan');
		});
	}

	/**
	 * tealiumイベントタグ
	 */
	public setUtagEvent(name: string, value: any): void {
		const cat = UTAG_EVENT_JSON[0].risk_factor;
		const ev = UTAG_EVENT_JSON[1].ev_select;
		switch (name) {
		case 'dest': 
			if (this.m_ProductCode === 'OTA') {
				for(let key of this.m_MasterData.wlDestinationMappingList) {
					if (key.destinationCountryCode === value)
						value = key.destinationCountryName;
				}
			} 
			postUtagEvent(cat, ev, 'country', value);
			break;
		case 'periodFrom':
			postUtagEvent(cat, ev, 'start_date', value);
			break;
		case 'periodTo':
			postUtagEvent(cat, ev, 'expiry_date', value);
			break;
		case 'person': 
			postUtagEvent(cat, ev, 'number_of_people', value);
			break;
		case 'purpose':
			postUtagEvent(cat, ev, 'purpose', value);
			break;	
		}
	}

	public onDisableClickOnInputElements(): void {
		// this.onPreventClickEvent(this, 'periodFrom');
		// this.onPreventClickEvent(this, 'periodTo');
		// this.onPreventClickEvent(this, 'purpose');
	}
	// --------------------------------------------------------------------------

	// privateメソッド  ----------------------------------------------------------
	/**
	 * リスクファクタ情報設定処理
	 * @param startDate 自宅から出発する日
	 * @param endDate 自宅に戻る日
	 */
	private setRiskFacrotInfo(startDate: string, endDate: string): void {
		this.m_RiskFactorInfo.agentCode = this.m_Agency;
		this.m_RiskFactorInfo.companyProductCode = this.productCode;
		this.m_RiskFactorInfo.startDate = startDate;
		this.m_RiskFactorInfo.endDate = endDate;
		if (this.m_ProductCode === 'OTA') {
			for(let key of this.m_MasterData.wlDestinationMappingList) {
				if (key.destinationCountryCode === this.m_RiskFactorInfo.destinationCountryCode) {
					this.m_RiskFactorInfo.destinationGovCode 	= key.destinationGovCode;
					// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 START
					//　方面グループコードはサーバ側からのレスポンスで取得
					// this.m_RiskFactorInfo.destinationGroupCode 	= 'TW11';
					// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 END
				}
			}
		} 
		else {
			this.m_RiskFactorInfo.destinationCountryCode 	= 'JPN';
			this.m_RiskFactorInfo.destinationGovCode 		= 'AS';
			// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 START
			//　方面グループコードはサーバ側からのレスポンスで取得
			// this.m_RiskFactorInfo.destinationGroupCode 		= 'KW11';
			// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 END
		}
		// WRQ-3496_ 【旅行保険】代理店追加対応 阪急交通社(ホワイトラベル）----------START
		// 問い合わせ番号が10桁の数字の場合会員番号に設定する
		this.m_RiskFactorInfo.memberNo = this.m_MemberNo;
		// WRQ-3496_ 【旅行保険】代理店追加対応 阪急交通社(ホワイトラベル）----------END
	}
	
	/**
	 * オプション表示判定
	 * @param today 
	 * @param startDate
	 * @returns true	：　オプション表示
	 * 			false	:　オプション非表示 
	 */
	private checkOption(today: Date, startDate: string): boolean {
		const convStartDate = new Date(startDate);
		const year = convStartDate.getFullYear();
		const month = convStartDate.getMonth();
		const day = convStartDate.getDate()-2;
		const startMinus2 = new Date(year, month, day);
		if (today >= startMinus2)
			return false;
		return true;		
	}

	/**
	 *  Date → string変換処理
	 */
	private dateToString(date: Date): string {
		let year 	= date.getFullYear();
		let month 	= ('00' + (date.getMonth() + 1)).slice(-2);
		let day 	= ('00' + date.getDate()).slice(-2);
		let hour 	= ('00' + date.getHours()).slice(-2);
		let minute 	= ('00' + date.getMinutes()).slice(-2);
		let second 	= ('00' + date.getSeconds()).slice(-2);
		return `${year}-${month}-${day} ${hour}:${minute}:${second}+0900`;
	}

	/**
	 * 保険終期設定処理
	 */
	private getEndDate(baseDate: Date, offSet: number): Date {
		const endDate = new Date(baseDate.getTime());
		endDate.setDate(endDate.getDate() + offSet);
		return endDate;
	}

	/**
	 * NationValueMap設定
	 * @param mappintList マッピング情報リスト
	 */
	private setNationValueMap(mappintList: WlDestinationMappingInfo[]): void {
		const vmName = 'nation';
		if (this.hasValueMap(vmName) === false) {
			const vm = new WprValueMap();
			if (mappintList !== null) {
				mappintList.forEach((info) => {
					vm.addValue(info.destinationCountryCode, info.destinationCountryName);
				});
			}
			this.addValueMap(vmName, vm);
		}
	}

	/**
	 * 補償キーリスト設定処理
	 * @param resList 
	 */
	private setCollKey(resList: CollateralDisplayInfo[]): string[] {
		this.m_CollKeyList = [];
		for(let key of resList) {
			if(!(key.collateralKey === this.EXTRA_COLLKEY_DTP 
				|| key.collateralKey === this.EXTRA_COLLKEY_OTA)){
				if (this.m_CollKeyList.includes(key.collateralKey) === false)
					this.m_CollKeyList.push(key.collateralKey);
			}
		}
		return this.m_CollKeyList;
	}

	/**
	 * 補償金額表示用リスト取得処理
	 * @param collSize 
	 * @param coverages 
	 */
	private getCollInfoList(collSize: number, coverages: Coverage[]): CollateralInfo[] {
		let collInfoList = [];
		let collInfoKeyList = [];
		for(let i=0; i<collSize; i++) {
			let collInfo = new CollateralInfo();
			collInfo.collateralKey 			= coverages[i].coverageCd;
			collInfo.collateralName 		= coverages[i].coverageDesc;
			collInfo.collateralAmount 		= coverages[i].coverageAmount;
			collInfoList.push(collInfo);
			collInfoKeyList.push(collInfo.collateralKey);
		}
		// 不足担保種目追加
		for(let k in this.m_CollKeyList) {
			if (collInfoKeyList.indexOf(this.m_CollKeyList[k]) == -1){
				let collInfo = new CollateralInfo();
				collInfo.collateralKey = this.m_CollKeyList[k];
				collInfo.collateralAmount = '-';
				collInfoList.splice(Number(k), 0, collInfo);
			}
		}
		return collInfoList;
	}

	/**
	 * 補償モーダル内表示用リスト取得処理
	 * @param resList 
	 */
	// private getCollDispList(resList: CollateralDisplayInfo[]): CollateralDisplayInfo[] {
	// 	let collDispsList: CollateralDisplayInfo[] = [];
	// 	for(let i in this.m_CollKeyList) {
	// 		let collDisp = new CollateralDisplayInfo();
	// 		collDisp.collateralKey 			= this.m_CollKeyList[i];
	// 		collDisp.collateralDescription 	= resList[i].collateralDescription;
	// 		collDisp.displayCollateralName 	= resList[i].displayCollateralName;
	// 		collDisp.collateralShortName	= resList[i].collateralShortName;
	// 		collDispsList.push(collDisp);
	// 	}
	// 	return collDispsList;
	// }
	private getCollDispList(colDispMap: Map<String, CollateralDisplayInfo>): CollateralDisplayInfo[] {
		let collDispsList: CollateralDisplayInfo[] = [];
		for(let i in this.m_CollKeyList) {
			if (colDispMap.has(this.m_CollKeyList[i]) === false)
				continue;
			collDispsList.push(colDispMap.get(this.m_CollKeyList[i]));
		}
		return collDispsList;
	}

	/**
	 * プランリストをプランコード順に並び替える
	 * @param planList
	 */
	private sortByPlanCode(planList: PlanByTravelWL[]) {
		planList.sort(function(a, b) {
			if(a.planCode < b.planCode)
				return -1;
			else
				return 1;
		});
	}

	/**
	 * brタグ挿入
	 */
	private insertBr(collDesc: string): string {
		if (collDesc.includes('<br />') === false) {
			const st = collDesc.slice(0,31);
			const br = '<br />';
			const en = collDesc.slice(31);
			return st+br+en;
		}
		return collDesc;
	}

	private checkRiskFactorInfoOnInit(): boolean {
		if (!this.m_RiskFactorInfo)
			return false;
		if (!this.m_RiskFactorInfo.destinationCountryCode)
			return false;
		if (!this.m_RiskFactorInfo.destinationGovCode)
			return false;
		if (!this.m_RiskFactorInfo.destinationGroupCode)
			return false;
		if (!this.m_RiskFactorInfo.startDate)
			return false;
		if (!this.m_RiskFactorInfo.endDate)
			return false;
		if (!this.m_RiskFactorInfo.numberOfInsured)
			return false;
		if (!this.m_RiskFactorInfo.purposeCode)
			return false;
		return true;
	}
	// ---------------------------------------------------------------------------
}
